import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebaseConfig";

export const getAllUsers = async (setUsers) => {

    const snap = await getDocs(
        collection(db, "users")
    );

    const list = snap.docs
        .map(doc => ({
            id: doc.id,
            ...doc.data()
        }))
        .filter(
            u =>
                u.username &&
                u.privacy === "public"
        );

    setUsers(list);
};